<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Team / Employees</div>
                <div class="page-bar-main">{{ formData.Name }}</div>
                <div v-if="formData.SeatTitle" class="page-bar-owner">{{ formData.SeatTitle }}</div>
            </div>
            <div style="display:flex;align-items:center" class="hide-mobile-991">
                <div class="btn-light" style="margin-right:15px" @click="$router.back()">Back</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.teamHubRole == 'Admin' || formData.ReportingTo == $store.state.user.teamHubEmployee?.ID" class="btn-row">
                <div class="btn" @click="() => { showReview = true }">Start review</div>
                <div class="btn-light" @click="() => { showAddEdit = true }">Edit record</div>
                <div class="btn-light" @click="() => { showEditRole = true }"><span v-if="rawEmployee.RoleSheetSlug">Update</span><span v-else>Assign</span> Role</div>
                <div class="btn-light" @click="() => { showEditChecklists = true }">Assign Checklists</div>
            </div>
            <div v-else class="btn-row">
                <div v-if="rawEmployee.RoleSheetSlug" class="btn" @click="() => { showViewRole = true }">View Role</div>
                <div v-for="(c, i) in checklists" :key="i" class="btn-light" @click="() => { checklistSlugToView = c.Slug; showChecklist = true; }">{{ c.Name }}</div>
            </div>
            <div class="emp-grid">
                <div class="emp-grid-main">
                    <div class="panel">
                        <h4 class="emp-h4">Record<span v-if="$store.state.user.teamHubRole == 'Admin'" class="panel-link" @click="() => { showAddEdit = true }">Edit Record</span></h4>
                        <div class="emp-record-grid">
                            <div>
                                <div class="emp-field-label">Name</div>
                                <div class="emp-field-value">{{ formData.Name || '—' }}</div>
                            </div>
                            <div>
                                <div class="emp-field-label">Email</div>
                                <div class="emp-field-value"><a v-if="formData.Email" :href="'mailto:'+formData.Email">{{ formData.Email }}</a><span v-else>—</span></div>
                            </div>
                            <div>
                                <div class="emp-field-label">Phone</div>
                                <div class="emp-field-value"><a v-if="formData.Phone" :href="'tel:'+formData.Phone">{{ formatPhone(formData.Phone) }}</a><span v-else>—</span></div>
                            </div>
                            <div>
                                <div class="emp-field-label">Title</div>
                                <div class="emp-field-value">{{ formData.SeatTitle || '—' }}</div>
                            </div>
                            <div>
                                <div class="emp-field-label">Team</div>
                                <div class="emp-field-value">{{ formData.Team || '—' }}</div>
                            </div>
                            <div v-if="additionalTeams.length">
                                <div class="emp-field-label">Additional Teams</div>
                                <div class="emp-field-value">{{ additionalTeams.join(', ') }}</div>
                            </div>
                            <div>
                                <div class="emp-field-label">Location</div>
                                <div class="emp-field-value">{{ formData.Location || '—' }}</div>
                            </div>
                            <div>
                                <div class="emp-field-label">Reporting To</div>
                                <div class="emp-field-value">{{ formData.ReportingToName || '—' }}</div>
                            </div>
                            <div v-for="(f, i) in formData.AdditionalFieldsJSON" :key="i">
                                <div class="emp-field-label">{{ f.name }}</div>
                                <div v-if="f.secure" class="emp-field-value">
                                    <a v-if="f.value" @click.prevent="getSecureField(f)">View</a>
                                    <span v-else>--</span>
                                </div>
                                <div v-else class="emp-field-value">{{ f.value || '—' }}</div>
                            </div>
                        </div>
                        <div v-if="formData.Status == 'Terminated'" class="emp-record-grid" style="margin-top:15px">
                            <div>
                                <div class="emp-field-label">Termination Details</div>
                                <div class="emp-field-value" v-html="formData.TerminationDetailsHTML || '—'"></div>
                            </div>
                            <div>
                                <div class="emp-field-label">Termination Date</div>
                                <div class="emp-field-value">{{ formData.TerminationDate || '—' }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="panel">
                        <h4 class="emp-h4">Accountabilities<span><a v-if="rawEmployee.RoleSheetSlug" @click.prevent="() => { showViewRole = true }" class="panel-link">View Role</a><span v-if="$store.state.user.teamHubRole == 'Admin' && rawEmployee.RoleSheetSlug"> | </span><router-link :to="'/edit-sheet/'+rawEmployee.RoleSheetSlug" v-if="$store.state.user.teamHubRole == 'Admin' && rawEmployee.RoleSheetSlug" class="panel-link">Set in Role Sheet</router-link></span></h4>
                        <ol v-if="accountabilities.length" class="emp-acc-list">
                            <li v-for="(a, i) in accountabilities" :key="i">{{ a.value }}<span v-if="a.value2" style="font-weight:normal">&nbsp;—&nbsp;{{ a.value2 }}</span></li>
                        </ol>
                        <div v-else-if="!rawEmployee.RoleSheetSlug" class="emp-empty">Employee has not been assigned a role.</div>
                        <div v-else class="emp-empty">Nothing added yet.</div>
                    </div>

                    <employee-tag-panel v-if="formData.ID" label="What I Value in Life" endpoint="valuesinlife" :employee-id="formData.ID" :items="formData.ValuesInLifeJSON" />

                    <employee-tag-panel v-if="formData.ID" label="What I Enjoy Doing" endpoint="enjoysdoing" :employee-id="formData.ID" :items="formData.EnjoysDoingJSON" />

                    <!-- What they've signed, latest per item (signoffs.ts /foremployee): for them, their manager and Team Hub admins -->
                    <div v-if="signOffsLoaded" class="panel">
                        <h4 class="emp-h4">Sign-offs</h4>
                        <div v-if="!hasStandardUser" class="emp-empty">No standard user is linked to this employee, so there's nothing to sign.</div>
                        <div v-else-if="!signOffs.length" class="emp-empty">Nothing signed yet.</div>
                        <div v-for="s in visibleSignOffs" :key="s.Slug" class="emp-signoff">
                            <div class="emp-signoff-main">
                                <router-link :to="'/playbook/' + s.Slug" class="emp-signoff-name">{{ s.Name }}</router-link>
                                <div class="emp-review-by">{{ $store.state.playbookNodeTypeMap[s.Type] }} · signed {{ s.DateDisplay }}</div>
                            </div>
                            <span class="pill" :class="s.Current ? 'p-done' : 'p-live'">{{ s.Current ? 'Current v' + s.Version : 'Needs to sign again' }}</span>
                        </div>
                        <a v-if="signOffs.length > 6" class="panel-link emp-signoff-more" @click.prevent="showAllSignOffs = !showAllSignOffs">{{ showAllSignOffs ? 'Show less' : 'Show all ' + signOffs.length }}</a>
                    </div>
                    <div class="panel">
                        <h4 class="emp-h4">Review History<span v-if="$store.state.user.teamHubRole == 'Admin'" class="panel-link" @click="() => { showReview = true }">Add review</span></h4>
                        <div v-if="!reviews.length" class="emp-empty">No reviews yet.</div>
                        <div v-for="(r, i) in reviews" :key="i" class="emp-review-card" @click="() => { r.expanded = !r.expanded }">
                            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px">
                                <div>
                                    <div class="emp-review-date">{{ r.DateDisplay }}</div>
                                    <div class="emp-review-by">Reviewed by {{ r.UserName }}</div>
                                </div>
                                <span class="pill p-done">Completed</span>
                            </div>
                            <template v-if="r.expanded">
                                <div v-for="(f, j) in r.Fields" :key="j" style="margin-top:10px">
                                    <div class="emp-field-label">{{ f.name }}</div>
                                    <div v-html="f.value"></div>
                                </div>
                            </template>
                            <div v-else-if="r.Fields.length" style="margin-top:10px" v-html="r.Fields[0].value"></div>
                        </div>
                    </div>
                </div>

                <div class="emp-grid-side">
                    <div class="panel emp-profile-card">
                        <div class="av emp-profile-av">{{ initials }}</div>
                        <div class="emp-profile-name">{{ formData.Name }}</div>
                        <div v-if="formData.SeatTitle" class="emp-profile-role">{{ formData.SeatTitle }}</div>
                        <span class="pill" :class="formData.Status == 'Terminated' ? 'p-live' : 'p-done'">{{ formData.Status }}</span>
                    </div>
                    <!-- Which logins sign in as this person; their meetings, task manager etc. follow either one -->
                    <div v-if="accounts" class="panel emp-accounts">
                        <h4 class="emp-h4">Sign-in accounts<span class="panel-link" @click="toggleEditAccounts()">{{ editingAccounts ? 'Cancel' : 'Change' }}</span></h4>
                        <template v-if="!editingAccounts">
                            <div class="emp-accounts-row">
                                <div class="emp-field-label">Admin account</div>
                                <div v-if="accounts.adminUser" class="emp-field-value">{{ accounts.adminUser.FirstName }} {{ accounts.adminUser.LastName }}<div class="emp-accounts-sub">{{ accounts.adminUser.Email }}</div></div>
                                <div v-else class="emp-empty">Not linked</div>
                            </div>
                            <div class="emp-accounts-row">
                                <div class="emp-field-label">Standard user</div>
                                <div v-if="accounts.publicUser" class="emp-field-value">{{ accounts.publicUser.FirstName }} {{ accounts.publicUser.LastName }}<div class="emp-accounts-sub">{{ formatPhone(accounts.publicUser.Phone) }}</div></div>
                                <div v-else class="emp-empty">Not linked</div>
                            </div>
                            <div v-if="accounts.adminUser && accounts.publicUser" class="emp-accounts-hint" style="margin:0">They can switch between Admin and Standard.</div>
                        </template>
                        <template v-else>
                            <div class="emp-accounts-row">
                                <label class="emp-field-label" for="emp-admin-account">Admin account</label>
                                <select id="emp-admin-account" v-model="accountsForm.UserID">
                                    <option :value="null">Not linked</option>
                                    <option v-for="u in adminChoices" :key="u.UserID" :value="u.UserID">{{ u.FirstName }} {{ u.LastName }} ({{ u.Email }})</option>
                                </select>
                            </div>
                            <div class="emp-accounts-row">
                                <label class="emp-field-label" for="emp-public-user">Standard user</label>
                                <select id="emp-public-user" v-model="accountsForm.PublicUserID">
                                    <option :value="null">Not linked</option>
                                    <option v-for="p in publicChoices" :key="p.ID" :value="p.ID">{{ p.FirstName }} {{ p.LastName }} ({{ formatPhone(p.Phone) }})</option>
                                </select>
                            </div>
                            <div class="emp-accounts-hint">Only accounts that aren't linked to another employee are listed.</div>
                            <div :class="savingAccounts ? 'btn disable-button' : 'btn'" @click="saveAccounts()">Save</div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <pdf-pop-up v-if="showChecklist" :url="`/playbook/${checklistSlugToView}?hideNav=t&hideComponent=t&hideChat=t&fullChecklist=t`" @close="() => showChecklist = false" />
        <team-hub-role-col v-if="showViewRole" @close="() => { showViewRole = false }" :slug="rawEmployee.RoleSheetSlug" :colID="rawEmployee.RoleSheetColID" />
        <add-edit-employee v-if="showAddEdit" :employeeToEdit="rawEmployee" @close="() => { showAddEdit = false; loadEmployee(); }" />
        <add-employee-review v-if="showReview" :employee="formData" :employeeReviewFields="employeeReviewFields" @close="() => { showReview = false; loadEmployee(); }" />
        <edit-employee-checklists v-if="showEditChecklists" :employeeToEdit="rawEmployee" @close="() => { showEditChecklists = false; loadEmployee(); }" />
        <edit-employee-role v-if="showEditRole" :employeeToEdit="rawEmployee" @close="() => { showEditRole = false; loadEmployee(); }" />
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import { findSeat, seatAccountabilities } from '@/roleSheet';
import axios from 'axios';
import AddEditEmployee from '@/components/AddEditEmployee.vue';
import AddEmployeeReview from '@/components/AddEmployeeReview.vue';
import EmployeeTagPanel from '@/components/EmployeeTagPanel.vue';
import EditEmployeeChecklists from '@/components/EditEmployeeChecklists.vue';
import EditEmployeeRole from '@/components/EditEmployeeRole.vue';
import TeamHubRoleCol from '@/components/TeamHubRoleCol.vue';
import PDFPopUp from '@/components/PDFPopUp.vue';

export default defineComponent({
    name: 'ViewEmployee',
    components: {
        AddEditEmployee,
        AddEmployeeReview,
        EmployeeTagPanel,
        EditEmployeeChecklists,
        EditEmployeeRole,
        TeamHubRoleCol,
        PdfPopUp: PDFPopUp
    },
    data() {
        return {
            rawEmployee: {} as any,
            formData: {
                ID: null,
                Status: 'Active',
                Name: '',
                Email: '',
                Phone: '',
                SeatTitle: '', // from their role sheet seat (API roleSheets.ts addSeatTitles)
                Location: '',
                AdditionalFieldsJSON: [] as any,
                ValuesInLifeJSON: [] as any,
                EnjoysDoingJSON: [] as any,
                TerminationDetails: '',
                TerminationDetailsHTML: '',
                TerminationDate: null as any,
                ReportingTo: null as any,
                ReportingToName: '',
                Team: ''
            },
            employeeFieldsClone: [] as any,
            employeeReviewFields: [] as any,
            reviews: [] as any,
            signOffs: [] as any[],
            hasStandardUser: false,
            signOffsLoaded: false,
            showAllSignOffs: false,
            showAddEdit: false,
            showReview: false,
            showEditChecklists: false,
            showEditRole: false,
            accountabilities: [] as any,
            showViewRole: false,
            checklists: [] as any,
            checklistSlugToView: null as any,
            showChecklist: false,
            accounts: null as any,
            accountsForm: { UserID: null as any, PublicUserID: null as any },
            editingAccounts: false,
            savingAccounts: false
        }
    },
    computed: {
        visibleSignOffs(): any[] {
            return this.showAllSignOffs ? this.signOffs : this.signOffs.slice(0, 6);
        },
        additionalTeams(): string[] {
            try {
                return JSON.parse((this.formData as any).AdditionalTeamsJSON || '[]');
            } catch(e) {
                return [];
            }
        },
        // The linked account first, then the unlinked ones it could be changed to
        adminChoices(): any[] {
            return this.accounts ? [ ...(this.accounts.adminUser ? [ this.accounts.adminUser ] : []), ...this.accounts.adminOptions ] : [];
        },
        publicChoices(): any[] {
            return this.accounts ? [ ...(this.accounts.publicUser ? [ this.accounts.publicUser ] : []), ...this.accounts.publicOptions ] : [];
        },
        initials(): string {
            if(!this.formData.Name) {
                return '';
            }
            const parts = this.formData.Name.trim().split(/\s+/);
            if(parts.length == 1) {
                return parts[0].substring(0, 2).toUpperCase();
            }
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }
    },
    async created() {
        while(!this.$store.state.allNodesLoaded) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        await this.loadEmployee();

        if(this.$store.state.user.teamHubRole == 'Admin') {
            await this.loadAccounts();
        }

        await axios.get(`${this.$store.state.apiUrl}/api/employees/reviewfields`)
            .then(resp => {
                if(resp.data) {
                    this.employeeReviewFields = resp.data;
                }
            })
            .catch(e => {
                console.log(e);
            })

        if(this.$route.query.edit) {
            this.showAddEdit = true;
        }

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async loadAccounts() {
            await axios.get(`${this.$store.state.apiUrl}/api/employees/${this.$route.params.id}/accounts`)
                .then(resp => {
                    this.accounts = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        toggleEditAccounts() {
            this.editingAccounts = !this.editingAccounts;
            this.accountsForm = {
                UserID: this.accounts.adminUser?.UserID || null,
                PublicUserID: this.accounts.publicUser?.ID || null
            };
        },
        async saveAccounts() {
            if(this.savingAccounts) {
                return;
            }
            this.savingAccounts = true;
            await axios.post(`${this.$store.state.apiUrl}/api/employees/${this.$route.params.id}/accounts`, this.accountsForm)
                .then(async () => {
                    await this.loadAccounts();
                    this.editingAccounts = false;
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error');
                })
            this.savingAccounts = false;
        },
        async loadEmployee() {
            this.employeeFieldsClone = JSON.parse(JSON.stringify(this.$store.state.employeeFields));
            let employeeToEdit: any;

            await axios.get(`${this.$store.state.apiUrl}/api/employees/${this.$route.params.id}`)
                .then(resp => {
                    employeeToEdit = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })

            if(!employeeToEdit) {
                alert('Employee was not found');
                this.$router.push('/employees');
                return;
            }

            this.checklists = [];
            try {
                const checklistsJSON = JSON.parse(employeeToEdit.ChecklistsJSON);
                for(const slug of checklistsJSON) {
                    const checklist = this.$store.state.allNodes.find((n: any) => {
                        return n.Slug == slug;
                    });
                    if(checklist) {
                        this.checklists.push(checklist);
                    }
                }
            } catch(e) {
                //
            }

            this.accountabilities = [];

            const found = findSeat(this.$store.state.allNodes, employeeToEdit.RoleSheetSlug, employeeToEdit.RoleSheetColID);
            if(found) {
                this.accountabilities = seatAccountabilities(found.seat);
            }

            this.rawEmployee = employeeToEdit;

            this.formData = JSON.parse(JSON.stringify(employeeToEdit));
            if(this.formData.TerminationDetails) {
                this.formData.TerminationDetailsHTML = this.formData.TerminationDetails.replace(/\n/g, '<br/>');
            }
            if(this.formData.TerminationDate) {
                const dateSplit = this.formData.TerminationDate.split('-');
                this.formData.TerminationDate = `${parseInt(dateSplit[1])}/${parseInt(dateSplit[2])}/${parseInt(dateSplit[0])}`;
            }
            if(this.formData.ValuesInLifeJSON) {
                try {
                    this.formData.ValuesInLifeJSON = JSON.parse(this.formData.ValuesInLifeJSON);
                } catch(e) {
                    this.formData.ValuesInLifeJSON = [];
                }
            } else {
                this.formData.ValuesInLifeJSON = [];
            }
            if(this.formData.EnjoysDoingJSON) {
                try {
                    this.formData.EnjoysDoingJSON = JSON.parse(this.formData.EnjoysDoingJSON);
                } catch(e) {
                    this.formData.EnjoysDoingJSON = [];
                }
            } else {
                this.formData.EnjoysDoingJSON = [];
            }
            if(this.formData.AdditionalFieldsJSON) {
                const additionalFields = JSON.parse(this.formData.AdditionalFieldsJSON);
                this.formData.AdditionalFieldsJSON = [];
                for(const field of this.employeeFieldsClone) {
                    const currentField = additionalFields.find((f: any) => {
                        return f.id == field.id;
                    });
                    if(currentField?.value) {
                        field.value = currentField.value;
                        if(field.type == 'date') {
                            const dateSplit = field.value.split('-');
                            field.value = `${parseInt(dateSplit[1])}/${parseInt(dateSplit[2])}/${parseInt(dateSplit[0])}`;
                        }
                    }
                    this.formData.AdditionalFieldsJSON.push(field);
                }
            } else {
                this.formData.AdditionalFieldsJSON = [];
                for(const field of this.employeeFieldsClone) {
                    this.formData.AdditionalFieldsJSON.push(field);
                }
            }

            await axios.get(`${this.$store.state.apiUrl}/api/employees/reviews/${this.formData.ID}`)
                .then(resp => {
                    for(const r of resp.data) {
                        r.DateDisplay = new Date(r.Date).toLocaleDateString();
                        r.ReviewJSON = JSON.parse(r.ReviewJSON);
                        r.Fields = [];
                        r.expanded = false;
                        for(const field of r.ReviewJSON) {
                            if(field.value) {
                                if(field.type == 'multitext') {
                                    field.value = field.value.replace(/\n/g, '<br/>');
                                } else if(field.type == 'date') {
                                    const dateSplit = field.value.split('-');
                                    field.value = `${parseInt(dateSplit[1])}/${parseInt(dateSplit[2])}/${parseInt(dateSplit[0])}`;
                                }
                                r.Fields.push(field);
                            }
                        }
                    }
                    this.reviews = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })

            // Hidden (not an error) for anyone the API doesn't allow: only them, their manager and Team Hub admins
            this.signOffsLoaded = false;
            await axios.get(`${this.$store.state.apiUrl}/api/signoffs/foremployee/${this.formData.ID}`)
                .then(resp => {
                    for(const s of resp.data.SignOffs) {
                        s.DateDisplay = new Date(s.Date).toLocaleDateString();
                    }
                    this.signOffs = resp.data.SignOffs;
                    this.hasStandardUser = resp.data.HasStandardUser;
                    this.signOffsLoaded = true;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        getSecureField(f: any) {
            axios.get(`${this.$store.state.apiUrl}/api/employees/securefield?employeeID=${this.formData.ID}&fieldID=${f.id}`)
                .then(resp => {
                    if(resp.data.val) {
                        alert(resp.data.val);
                    } else {
                        alert('Data not found')
                    }
                })
                .catch(e => {
                    console.log(e);
                    alert('Data not found')
                })
        }
    }
});
</script>
